import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap-5';

export default class DeleteTaskModal extends React.Component {
  static propTypes = {
    shown: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
  };

  render() {
    const { shown, onCancel, onDelete } = this.props;

    return (
      <Modal
        centered
        className='contact-modal overflow-auto'
        name='task-delete-modal'
        show={shown}
        onHide={onCancel}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>Are you sure you want to delete this task entirely?</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-ghost' onClick={onCancel}>Cancel</button>
          <button
            className='btn btn-destructive'
            onClick={onDelete}
          >
              Delete
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
